import { Paper, Typography } from "@mui/material";
import { change, formatNumber } from "../format";

const ARROW = { up: "▲", down: "▼", flat: "■" };

/** A headline number, and how it moved against the equally long period before. */
export default function KpiTile({ label, value, previous, format = formatNumber }: {
  label: string; value: number | null; previous?: number; format?: (n: number | null) => string;
}) {
  const moved = previous === undefined || value === null ? null : change(value, previous);
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Typography variant="h4" sx={{ my: 0.5 }}>{format(value)}</Typography>
      {moved && (
        <Typography variant="caption" color="text.secondary">
          {ARROW[moved.direction]} {moved.text} vs previous period ({format(previous ?? null)})
        </Typography>
      )}
    </Paper>
  );
}
